import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { messages } from './AcceptTouForm.i18n';

class AcceptTouForm extends Component {
  constructor(props) {
    super(props);

    // This binding is necessary to make `this` work in the callback
    this.state = {
      accepted: false,
      errorDisplayed: false,
    };
    this.onAcceptClick = this.onAcceptClick.bind(this);
    this.onCancelClick = this.onCancelClick.bind(this);
  }

  componentDidMount = () => {
    // To control browser's back button click
    window.onpopstate = this.onCancelClick;
  };

  onAcceptClick = (event) => {
    event.preventDefault();
    if (this.state.accepted) {
      this.props.handleAcceptTou();
    } else {
      this.setState({ errorDisplayed: true });
    }
  };

  onCancelClick = (event) => {
    event.preventDefault();
    this.props.handleCancel();
  };

  handleChange = () => {
    this.setState({ accepted: !this.state.accepted });
    this.setState({ errorDisplayed: false });
  };

  render() {
    return (
      <div className="card p-3">
        <div className="card-body">
          <div className="content-area">
            <p tabIndex="0" data-qa-item="touAcceptBelowHint">
              <FormattedMessage {...messages.required.hint} />
            </p>
            <div className="clearfix scrollbox mb-3">
              <div data-qa-item="touContent" dangerouslySetInnerHTML={{ __html: this.props.touContent }}></div>
            </div>
          </div>
          <form onSubmit={this.onAcceptClick}>
            <div className="checkbox tou mb-3">
              <label data-qa-item="touDeclareLabel">
                <input type="checkbox" id="checkboxAccept" onChange={this.handleChange} checked={this.state.checked} />
                &nbsp;<FormattedMessage {...messages.declare.label} />
              </label>
            </div>
            {
              this.state.errorDisplayed ?
              <div className="alert alert-danger mb-3" role="alert" data-qa-item="continueWOAcceptError">
                <FormattedMessage {...messages.declare.error} />
              </div> :
                null
            }
            <a type="button" className="btn btn-primary mr-1" data-qa-item="continueButton"
              onClick={this.onAcceptClick}
              href="#"
            >
              <FormattedMessage {...messages.buttons.continue} />
            </a>
            <a type="button" className="btn btn-link" data-qa-item="cancelButton"
              onClick={this.onCancelClick}
              href="#"
            >
              <FormattedMessage {...messages.buttons.cancel} />
            </a>
          </form>
        </div>
      </div>
    );
  }
}

AcceptTouForm.propTypes = {
  handleCancel: PropTypes.func.isRequired,
  handleAcceptTou: PropTypes.func.isRequired,
  error: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.object,
  ]),
  touContent: PropTypes.string,
};

const mapStateToProps = (state) => ({
  touContent: state.profile.user.termsOfUse,
});


export default connect(mapStateToProps)(AcceptTouForm);